import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';

import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import config from 'config/index';
import * as loglevel from 'config/loglevel';

import types from '../actionTypes';
import { getOrder } from './utilities';
import { imageMapsRequest } from '../actions';

const { takeEvery, put } = sagaEffects;

function* handler({ payload: image }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();

    try {
        let ref = yield firestore.collection(`languages/${config.app.defaultLanguage}/imageMaps`);
        const order = yield getOrder(ref);
        const data = {
            order,
            image,
        };

        const { id } = yield ref.add(data);

        const languages = config.app.languages.filter(l => l !== config.app.defaultLanguage);
        for (const lang of languages) {
            ref = yield firestore.doc(`languages/${lang}/imageMaps/${id}`);
            yield ref.set(data);
        }
        yield put(imageMapsRequest({ silent: true }));
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.maps.image.add' }));
    }
}
export default function* () {
    yield takeEvery(types.ADD_IMAGE_MAP_REQUEST, handler);
}
